import { render, staticRenderFns } from "./WechatSignup.vue?vue&type=template&id=2d17194d&"
import script from "./WechatSignup.vue?vue&type=script&lang=js&"
export * from "./WechatSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports